const Form091EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        declaration: "Confirmation",
    },
    noteList: {
        note1: "Application for Funding Support to Provide Off-school Advanced Learning Programmes for Gifted Students ({{schoolyear}} school year)",
        note2: "Points to note:",
        note3: 'Please read the Guide to Applicants (<a style="color: blue" href="https://www.edb.gov.hk/en/curriculum-development/curriculum-area/gifted/ge_fund/gef/asp.html" target="_blank" rel="noopener noreferrer">https://www.edb.gov.hk/en/curriculum-development/curriculum-area/gifted/ge_fund/gef/asp.html</a>) carefully before you fill out this application form.',
        note4: "One application form should be completed for each programme.  An organisation may submit more than one application.",
        note5: "Reminders:",
        note6: "Please submit this application form with the programme proposal to the ",
        note7: "Gifted Education Fund Secretariat no later than {{deadline}}.",
        note8: "Documents to be uploaded:",
        note8_1:
            "One duly completed application form with the programme proposal.",
        note8_2:
            "A photocopy of the applicant organisation’s relevant registration document (e.g. Business Registration Certificate) or exemption from tax under section 88 of the Inland Revenue Ordinance, if applicable.",
        number1: "1.",
        number2: "2.",
        number3: "3.",
        number4: "4.",
        number5: "5.",
        number6: "6.",
        number7: "7.",
        tooltip:
            "For example, Head of department/ faculty of a post-secondary institution or Chairman/ Executive Director of an organisation",
        tooltip_totalMonths:
            "This figure is automatically generated from the sum of (a) preparation and (b) programme delivery.",
        tooltip_totalGrantSought:
            "This figure is automatically generated from the total grant sought in Part B and budget plan in Part C",
        iamStatement:
            "I understand applicant and the approving authority of the applicant organization need to have an “iAM Smart+” account to process the application.",
        additionNotice_1:
            "Please print the PDF file for signature of the head of organisation and/ or supporting organisation with organisation chop.",
    },
    label: {
        partA: "Part A: Programme particulars",
        titleOfProgramme: "Title of programme",
        english: "(English)",
        chinese: "(Chinese)",
        themeOfProgramme: "Theme(s) of programme",
        theme: "theme",
        pleaseSpecify: "please specify",
        openBracket: "(",
        closeBracket: ")",
        underline: "_____________",
        targetBeneficiary: "Target beneficiary",
        target: "target",
        targetPrefer:
            "(preferably around 50 students; e.g. 50 students at Secondary 1 and 2)",
        targetBeneficiaryNumber: "(a) number of students",
        targetBeneficiaryLevel: "(b) levels",
        programmePeriod: "Programme period:",
        months: "months",
        preparation: "(a) preparation (3 months)",
        preparation1: "(a) preparation ",
        preparation2: "(3 months)",
        delivery: "(b) programme delivery (no more than 5 months): ",
        delivery1: "(b) programme delivery ",
        delivery2: "(no more than 5 months): ",
        total: "(c) total: ",
        grantSought: "Grant sought: Total HK$",
        particularsOfOrganisation: "Particulars of organisation:",
        applicantOrganisation: "Applicant organisation",
        supportingOrganisation: "Supporting organisation(s) (if any)",
        supportingOrganisations: "Supporting organisation(s)",
        name: "Name of organisation",
        headOfOrganisation: "Name of head",
        postTitle: "Post title",
        address: "Address",
        programmeLeader: "Particulars of programme leader:",
        nameAndPost: "Name",
        post: "Post",
        telephoneNumber: "Telephone number",
        officeHours: "(Office hours)",
        outsideOfficeHours: "(Outside office hours)",
        emailAddress: "Email address",
        emailMain: "(Primary Email)",
        emailBackup: "(Backup Email)",
        faxNumber: "Fax number",
        partB: "Part B: Summary of programme proposal",
        provideSummary:
            "Please provide a summary of the proposed programme below in one page of A4 size with font size no smaller than 12.",
        goal: "Goals and objectives",
        selection:
            "Selection mechanism of gifted student participants (e.g. information provided in the student application form/ a written test/ an interview)",
        mechanism: "selection mechanism",
        implementation1: "Programme implementation:",
        implementation2:
            "Major preparation work (e.g. manpower arrangement, preparation of programme materials)",
        implementation3:
            "Brief description of the programme (e.g. Phase 1: 30 hours of general introduction to foundation knowledge and skills related to meteorology; Phase 2: 30 hours of in-depth study of more advanced topics; Phase 3: 3 months of independent project under mentorship; Phase 4: Showcase of students’ achievement in a public event)",
        implementation4:
            "Duration and frequency of meeting (e.g. 9 months [one 3-hour lesson/ meeting per week])",
        implementation5:
            "Manpower and staff recruitment (e.g. recruitment of 1 full-time programme assistant to assist in the administration of the programme)",
        implementation6:
            "Collaboration with other parties/ organisations (e.g. collaboration with a local professional body)",
        description: "description",
        grantSoughtAndExpenditure:
            "Grant sought and expenditure items (in HK$):",
        staffCost: "Staff Cost",
        equipment: "Equipment",
        services: "Services",
        generalExpenses: "General expenses",
        contingency: "Contingency",
        others: "Others (please specify)",
        totalGrantSought: "Total grant sought",
        expected:
            "Expected learning outcomes and tangible deliverables of students",
        current:
            "Current networks with primary and secondary schools (if any) or proposed promotion plan to boost student enrolments",
        proposed:
            "Proposed quality assurance mechanism: (e.g. set up a quality assurance team, conduct quality review meetings once every 3 months, evaluate students’ learning effectiveness and collect feedback through interviews and questionnaires, etc.)",
        proposedQualityAssuranceMechanism:
            "proposed quality assurance mechanism",
        networkOrPlan: "network or plan",
        partC: "Part B: Programme content",
        elaborate:
            "A proposed programme will be assessed in accordance with, but not limited to, the following three areas: (I) programme needs; (II) programme feasibility; and (III) expected learning outcomes and quality assurance.",
        programmeNeeds: "(I) Programme needs",
        programmeFeasibility: "(II) Programme feasibility",
        expectedOutcome:
            "(III) Expected learning outcomes and quality assurance",
        rationale: "Rationale",
        rationale2: "(Why do you propose this programme?)",
        goal2: "(e.g.",
        goal3: "Goal: to further unleash the potential of gifted students",
        goal4: "Objectives: to enhance the ability of gifted students in integration and application of knowledge and skills across disciplines to solve advanced scientific problems; and to develop students’ positive values and attitudes to cope with adversities)",
        hyphen: "-",
        goal5: "to enhance the ability of gifted students in integration and application of knowledge and skills across disciplines to solve advanced scientific problems; and",
        goal6: "to develop students’ positive values and attitudes to cope with adversities)",
        targetBeneficiary2: "(e.g. 50 students at Secondary 1 and 2)",
        prerequisite1: "Pre-requisite",
        prerequisite2:
            "(e.g. Students should demonstrate outstanding performance in science/ mathematics in schools and possess basic computer programming knowledge. If not, please input NIL.)",
        prerequisite3: "(If not, please input NIL.)",
        selection1: "Selection mechanism",
        selection2:
            "(e.g. information provided in the student application form/ a written test/ an interview [please elaborate])",
        programmePeriod1: "Programme period",
        programmePeriod2: "{{periodExample}}",
        programmePeriodPreparation: "programme period of preparation",
        programmePeriodDelivery: "programme period of delivery",
        preparationPartC: "Preparation:",
        deliveryPartC: "Delivery:",
        fromPartC: "from",
        toPartC: "to",
        mediumOfInstruction1: "Medium of instruction",
        mediumOfInstruction2: "Programme material: ",
        mediumOfInstruction3: "(e.g. English)",
        mediumOfInstruction4: "Class teaching/ discussion: ",
        mediumOfInstruction5:
            "(e.g. primarily English, supplemented with Cantonese)",
        keyImplementation1: "Key implementation details:",
        keyImplementation2:
            "(Excluding the preparation period, the delivery of a programme should be between 5 and 7 months. Each programme should not exceed 100 contact hours. Please elaborate on the lesson content, learning and teaching activities, mode [online/ face-to-face], number of sessions, etc. at different periods of the programme.  Insert row[s] in the table below and/ or stagger the implementation of programme into phases if necessary. Applicants may attach supporting documents to illustrate the implementation of the programme if necessary.)",
        eg1: "Example",
        implementationPeriod1: "Implementation period (MM/YY to MM/YY)",
        implementationPeriod2: "May to July 202X",
        implementationPeriod3: "implementation period",
        numContactHours: "Number of contact hours (input numbers only)",
        numContactHours1: "30",
        content1: "Content/ Activities/ Mode/ Sessions",
        content2:
            "(e.g. Phase 1: Acquisition of foundation knowledge on meteorology and use of cloud computing technique to simulate the path of a tropical cyclone and estimate the relevant storm surge: 8 topics on meteorology/ numerical analysis in 8 face-to-face lessons [3 hours each] plus 6 hours on computer programming [a total of 30 hours in 3 months])",
        content2_1: "Phase 1 (3 months, 30 hours)",
        content2_2:
            "In-person classes: Basic meteorology and use of cloud computing to simulate tropical cyclone paths and estimate storm surges.",
        content2_3:
            "8 sessions (3 hours each) on meteorology/data analysis, and 1 session (6 hours) on computer programming",
        manpower1: "Manpower plan:",
        manpower2: "(Please insert row[s] if necessary)",
        post1: "Post",
        post2: "one programme assistant",
        qualification1:
            "Academic qualification(s) and/or professional qualification(s) and/or work experience",
        qualification2:
            "(e.g. a Bachelor degree or above in Science-related fields and at least 3 years of relevant experience in organising training programmes)",
        qualification2_1:
            "(a) a Bachelor degree or above in science-related fields; and",
        qualification2_2:
            "(b) at least 3 years of relevant experience in organising training programmes",
        roles1: "Roles/ Duties",
        roles2: "(please specify: full-time / part-time / total number of months/ hours)",
        roles3: "( e.g. (a) to assist in the general administration of the programme; and (b) to assist in student-related matters related to the programme)",
        roles3_1:
            "(a) to assist in the general administration of the programme; and",
        roles3_2:
            "(b) to assist in student-related matters related to the programme",
        engagementMode1: "Mode of engagement",
        engagementMode2:
            "full-time (calculated in months) / </br>part-time (calculated in hours) / </br>others (please specify)",
        engagementTime1: "Number of months/ hours of engagement",
        engagementTime2: "6 months",
        engagementMonths: "months",
        engagementHours: "hours",
        budgetPlan1: "Budget plan:",
        budgetPlan2:
            "(Please refer to the “Guidelines on Budget Planning” at Annex I of the Guide to Applicants)",
        items: "Items",
        particulars: "Particulars with justifications",
        breakdown: "Breakdown",
        amount: "Amount (in HK$)",
        respectiveRoles:
            "Respective roles of applicant organisation and supporting organisation(s) (if applicable):",
        role: "role",
        experience:
            "Relevant experience in gifted education/ talent development (if applicable):",
        experience2: "experience",
        currentNetworks1:
            "Current networks with primary and secondary schools (if any) or proposed promotion plan to boost student enrolments:",
        currentNetworks2:
            "(e.g. arrange an online briefing session to introduce the programme to schools)",
        expectedLearningOutcomes1:
            "Expected learning outcomes and tangible deliverables of students: ",
        expectedLearningOutcomes2:
            "(e.g. By the end of the programme, students should be able to master cloud computing technique to solve advanced scientific problems including…;students will present a research paper in a showcase event)",
        expectedLearningOutcomes3:
            "expected learning outcomes and tangible deliverables of students",
        proposed2: "Proposed quality assurance mechanism: ",
        proposed3:
            "(The proposed mechanism should include composition of the quality assurance team and appropriate measures such as the frequency and modes of evaluation to be conducted, training and pre-lesson preparation among instructors, etc. to maintain the quality of the programme.)",
        partD: "Part C: Declaration and consent",
        iHaveRead:
            "I have read and fully understood the <b>Guide to Applicants</b>.  I certify that our organisation meets the eligibility criteria for application and that there is no duplication of funding for the same programme(s) from other government sources.",
        iCertify:
            "I certify that all the information given in this application is true and accurate.  I understand that any inaccurate information will render the application invalid, any grant approved will be withheld and any payment made must be refunded to the Gifted Education Fund.",
        iAgree: "I have read the Personal Information Collection Statement stipulated in Annex II of the Guide to Applicants. I agree that the information provided in this application will be used by the Gifted Education Fund Secretariat and related government bureaux/ departments to process the application and for other directly related purposes.",
        iUnderstand:
            "I understand that proposals submitted will be processed on a competitive basis for the Gifted Education Fund and the Education Bureau reserves the right of final decision in the selection process.",
        nameAndPostTitle: "Name and post title",
        postTitleD: "Post title",
        nameOfOrganisation: "Name of organisation",
        attachment: "Attachment",
        attachmentNote: "Reminders",
        edbDocument: "Attachment (uploaded by EDB)",
    },
    select: {
        engagementMode: {
            fullTime: "full-time (calculated in months)",
            partTime: "part-time (calculated in hours)",
            others: "others (please specify)",
        },
        targetBeneficiaryLevel: {
            primary: "(i) upper primary (P4-P6)",
            secondary: "(ii) junior secondary (S1-S3)",
            higher: "(iii) senior secondary (S4-S5)",
            secondaryAndHigher: "(iv) junior and senior secondary (S1-S5)",
        },
    },
    formContent: {
        themeOfProgrammeOption: {
            stem: "Digital Education / STEAM-related Advanced Learning",
            humanities: "Humanities and Social Science Research Programme",
            apprenticeship: "Apprenticeship and Entrepreneurship Programme",
            selfInitiated: "Self-initiated Research Study",
            others: "Others",
        },
    },
    errorMsg: {
        telNo: "Telephone number must be exactly 8 digits",
        faxNo: "Fax number must be exactly 8 digits",
        differentFromPartC:
            "Input value should be equal to “Part C - Budget plan Total grant sought”",
        differentFromPartB:
            "Input value should be equal to “Part B - 4. Total Grant Sought”",
        delivery: "Please input a valid programme delivery",
        numContactHoursTotal:
            "The total number of contact hours should not exceed 100",
        engagementTime: "allow a numeric input from 0-200",
        targetBeneficiary: "allow a numeric input from 30-60",
    },
    pics: {
        title: "Personal Information Collection Statement",
        h1: "Purpose of Collection",
        p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        p1_1_a: "Activities relating to the processing, authentication and counter-checking of the application for funding support under Gifted Education Fund;",
        p1_1_b: "Activities  relating  to  matching  of  the  personal  data  with  the  database  of other relevant Government bureaux / departments in connection with the processing,   authentication   and   counter-checking   of   the   application mentioned in (a) above;",
        p1_1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        p1_1_d: "Activities  relating  to  training  and  development  including  invitation  of participation in programmes / activities, applications for reimbursement of course  fees,  assessment  of  nominations,  awards  and  scholarship,  and monitoring of attainment progress;",
        p1_1_e: "Activities  relating  to the  processing  and  vetting  of  applications  for,  and disbursement of, funding / grants / subsidies, and conducting of audits;",
        p1_1_f: "Activities  relating  to  compilation  of  statistics,  research  and  Government publications; and",
        p1_1_g: "Activities  relating  to  the  administration  and  enforcement  of  rules  and regulations  including  the  Education  Ordinance  (Cap.  279),  its  subsidiary legislation  (such  as  the  Education  Regulations  and  the  Grant / Subsidised Schools Provident Fund Rules) and the Codes of Aid.",
        p1_2: "The  provision  of  personal  data  required  by  this  form  and  during  the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

        h2: "Classes of Transferees",
        p2_3: "The personal data you provide will be made available to persons working in EDB.   Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        p2_3_a: "other Government bureaux and departments, including Education Bureau, for the purposes mentioned in paragraph 1 above;",
        p2_3_b: "the  school  to  which  the  form  relates  for  the  purposes  mentioned  in paragraph 1 above;",
        p2_3_c: "where you have given your prescribed consent to such disclosure; and",
        p2_3_d: "where  such  disclosure  is  authorised  or  required  under  the  law  or  court order applicable to Hong Kong.",

        h3: "Access to Personal Data",
        p3_4: "You  have  the  right  to  request  access  to  and  correction  of  your  personal data held by EDB.   Request for access or correction of personal data should be made in writing to the Executive Officer (Gifted Education) at Room E328, 3/F, East  Block,  Education  Bureau  Kowloon  Tong  Education  Services  Centre,  19 Suffolk Road, Kowloon Tong, Kowloon or at exoge@edb.gov.hk.",
    },
    dialog: {
        title: "*** Application procedures are NOT completed yet ***",
        content: `Application procedures are not completed yet. You are required to complete the following procedures:<br />
        <br />
        1. download the application form you have submitted and print it;<br />
        2. ask the head of organisation to sign and stamp the application form; and<br />
        3. scan the signed and stamped application form and upload it onto the system<br />
        <br />
        Please note that an email of notification has been sent to your registered email address, reminding you that your application procedures are NOT completed yet.<br />
        <br />
        When you have completed all application procedures and your application has been received by EDB, you will receive a confirmation email.`,
    },
};

export default Form091EN;
